import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

export interface ContentImageCard {
	title: string;
	description?: string;
	thumbnail?: string;
	format?: 'audio' | 'video' | 'page' | 'link' | 'document' | 'image';
	duration?: number;
	status?: string;
	rating?: number;
	commentsCount?: number;
	playlistItemCount?: number;
	creator?: string;
	date?: string;
	type?: string;
	userThumbnail?: string;
	actions?: Array<{
		caption: string,
		key: string,
		classes: string | Array<string>
	}>;
	removable?: boolean;
	promotion?: boolean;
	courseDuration?: string;
	usersCount?: number;
	forwarderName?: string;
	forwarderThumbnail?: string;
	read?: boolean;
}

@Component({
	selector: 'app-content-image-card',
	templateUrl: './content-image-card.component.html',
	styleUrls: ['./content-image-card.component.scss']
})
export class ContentImageCardComponent implements OnInit, OnChanges {

	@Input() type: 'horizontal' | 'vertical' | 'minimal' = 'horizontal';
	@Input('record') data: ContentImageCard;
	@Output() remove: any = new EventEmitter();
	@Output() detail: any = new EventEmitter();
	@Output() users = new EventEmitter<boolean>();
	@Output() profile: any = new EventEmitter();
	@Output() promote: any = new EventEmitter();
	@Output() action: any = new EventEmitter();
	@Output() forwarderUser: any = new EventEmitter();
	@Input() pure = false;

	cardData;
	test = false;
	profileData;

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) {
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		if (changes.data && changes.data.currentValue) {
			this.cardData = changes.data.currentValue;
			if (!([null, undefined].includes(changes.data.currentValue.rating))) {
				if (changes.data.currentValue.rating > 5) {
					changes.data.currentValue.rating = 5;
				}
				const range = this.range(0, Number(parseFloat(changes.data.currentValue.rating.toString())));
				range.splice(0, 1);
				for (let i = range.length; i < 5; i++) {
					range.push(0);
				}
				this.cardData.ratingData = range.map(data => {
					return {
						isInt: this.isInt(data),
						isFloat: this.isFloat(data),
						value: data
					};
				});
			}
		}
	}

	private range(start: number, end: number) {
		const foo: number[] = [];
		let endValue: any = end.toString().split('.');
		if (endValue.length) {
			endValue = Number(endValue[0]);
		}
		for (let i = start; i <= end; i++) {
			if (i === endValue) {
				foo.push(end);
			} else {
				foo.push(i);
			}
		}
		return foo;
	}

	isInt(n) {
		return Number(n) === n && n % 1 === 0;
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	close(data) {
		if (navigator.onLine) {
			this.remove.emit(data);
		}
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	profileInfo(data) {
		if (navigator.onLine) {
			this.profile.emit(data);
		}
	}

	usersInfo() {
		if (navigator.onLine) {
			this.users.emit(true);
		}
	}

	promotion(data) {
		if (navigator.onLine) {
			this.promote.emit(data);
		}
	}

	actionInfo(action) {
		if (navigator.onLine) {
			this.action.emit(action);
		}
	}

	forwarderUserInfo(data) {
		if (navigator.onLine) {
			this.forwarderUser.emit(data);
		}
	}

	getUserInfo() {
		this.profileData = {
			title: 'Hema Pillai',
			profileThumbnail: null,
			progress: 50,
			contactInfo: ['Manager - IT Company', 'Department', 'City', 'Location'],
			shortInfo: [
				{
					value: '8+ years exp'
				},
				{
					value: 'joined 2.4 years ago'
				}
			],
			designation: 'test',
			membersCount: 2,
			workGroupOwnerName: 'test',
			workGroupOwnerCount: 2
		};
		console.log('test')
	}

}
